import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-33c1fe46")

_pushScopeId("data-v-33c1fe46")
const _hoisted_1 = /*#__PURE__*/_createTextVNode("Banca ore")
const _hoisted_2 = {
  key: 0,
  class: "loading_spinner"
}
const _hoisted_3 = {
  key: 1,
  class: "page_content"
}
const _hoisted_4 = { class: "counter_container" }
const _hoisted_5 = { class: "counter" }
const _hoisted_6 = {
  key: 0,
  class: "no_ore_container"
}
const _hoisted_7 = /*#__PURE__*/_createVNode("div", { class: "no_ore" }, "Non hai ore da utilizzare", -1)
const _hoisted_8 = {
  key: 1,
  class: "container_ore"
}
const _hoisted_9 = { class: "title" }
const _hoisted_10 = { class: "status" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_ion_title = _resolveComponent("ion-title")
  const _component_ion_icon = _resolveComponent("ion-icon")
  const _component_ion_button = _resolveComponent("ion-button")
  const _component_ion_buttons = _resolveComponent("ion-buttons")
  const _component_ion_toolbar = _resolveComponent("ion-toolbar")
  const _component_ion_header = _resolveComponent("ion-header")
  const _component_ion_spinner = _resolveComponent("ion-spinner")
  const _component_ion_content = _resolveComponent("ion-content")
  const _component_ion_page = _resolveComponent("ion-page")

  return (_openBlock(), _createBlock(_component_ion_page, null, {
    default: _withId(() => [
      _createVNode(_component_ion_header, { translucent: true }, {
        default: _withId(() => [
          _createVNode(_component_ion_toolbar, null, {
            default: _withId(() => [
              _createVNode(_component_ion_title, { color: "white" }, {
                default: _withId(() => [
                  _hoisted_1
                ]),
                _: 1
              }),
              _createVNode(_component_ion_buttons, {
                onClick: _cache[1] || (_cache[1] = ($event: any) => ($setup.openMenu())),
                slot: "start"
              }, {
                default: _withId(() => [
                  _createVNode(_component_ion_button, null, {
                    default: _withId(() => [
                      _createVNode(_component_ion_icon, {
                        icon: $setup.menu,
                        slot: "start"
                      }, null, 8, ["icon"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_ion_buttons, { slot: "end" }, {
                default: _withId(() => [
                  _createVNode(_component_ion_button, {
                    onClick: _cache[2] || (_cache[2] = ($event: any) => ($setup.loadBancaOre()))
                  }, {
                    default: _withId(() => [
                      _createVNode(_component_ion_icon, {
                        slot: "start",
                        icon: $setup.refresh,
                        color: "white"
                      }, null, 8, ["icon"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_ion_content, { fullscreen: true }, {
        default: _withId(() => [
          ($setup.loading)
            ? (_openBlock(), _createBlock("div", _hoisted_2, [
                _createVNode(_component_ion_spinner, {
                  name: "crescent",
                  color: "dark"
                })
              ]))
            : (_openBlock(), _createBlock("div", _hoisted_3, [
                _createVNode("div", _hoisted_4, [
                  _createVNode("div", _hoisted_5, "Banca ore: " + _toDisplayString($setup.calcolaSaldo), 1)
                ]),
                (!$setup.banca_ore.length)
                  ? (_openBlock(), _createBlock("div", _hoisted_6, [
                      _hoisted_7
                    ]))
                  : (_openBlock(), _createBlock("div", _hoisted_8, [
                      (_openBlock(true), _createBlock(_Fragment, null, _renderList($setup.banca_ore, (ora) => {
                        return (_openBlock(), _createBlock("div", {
                          class: "ora",
                          key: ora.banca_ore_id
                        }, [
                          _createVNode("div", _hoisted_9, _toDisplayString(parseFloat(ora.banca_ore_hours).toFixed(2)) + " ore il " + _toDisplayString($setup.dateFormat(ora.banca_ore_data)), 1),
                          _createVNode("div", _hoisted_10, [
                            _createVNode("div", {
                              class: ["badge", $setup.tipoMovimento(ora.banca_ore_movimento)]
                            }, _toDisplayString(ora.banca_ore_movimento_value), 3)
                          ])
                        ]))
                      }), 128))
                    ]))
              ]))
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
})